import React, { useState, useEffect } from 'react';
import axios from 'axios';

const MonitoringKBM = ({ token }) => {
  const [jadwal, setJadwal] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Deteksi Hari Ini (Senin, Selasa, dst)
  const hariIndo = ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'];
  const today = hariIndo[new Date().getDay()];
  
  const [selectedHari, setSelectedHari] = useState(today === 'Minggu' ? 'Senin' : today);
  const [tanggal, setTanggal] = useState(new Date().toISOString().split('T')[0]);

  useEffect(() => {
    fetchMonitoring();
    // Auto refresh setiap 30 detik biar real-time
    const interval = setInterval(fetchMonitoring, 30000);
    return () => clearInterval(interval);
  }, [selectedHari, tanggal]);

  const fetchMonitoring = async () => {
    setLoading(true);
    try {
      // --- FIX: Menggunakan relative path agar aman saat pindah domain / VPS ---
      const res = await axios.get(`/api/monitoring-kbm`, {
        params: { hari: selectedHari, tanggal: tanggal },
        headers: { Authorization: `Bearer ${token}` }
      });
      setJadwal(res.data);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  // Hitung Statistik Ringkas
  const totalKelas = jadwal.length;
  const kbmAktif = jadwal.filter(j => j.status_kbm === 'berjalan').length;
  const belumHadir = totalKelas - kbmAktif;

  return (
    <div style={{ paddingBottom: '50px' }}>
      
      {/* HEADER & FILTER */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '25px', flexWrap:'wrap', gap:'15px' }}>
        <div>
            <h2 style={{ color: '#1e293b', margin: 0 }}>📡 Monitoring KBM Real-time</h2>
            <p style={{ margin: '5px 0 0', color: '#64748b' }}>Pantau aktivitas belajar mengajar di seluruh kelas.</p>
        </div>

        <div style={{ display: 'flex', gap: '10px', background: 'white', padding: '10px', borderRadius: '10px', boxShadow: '0 2px 5px rgba(0,0,0,0.05)' }}>
            <select 
                value={selectedHari} 
                onChange={(e) => setSelectedHari(e.target.value)} 
                style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #cbd5e1', fontWeight: 'bold' }}
            >
                {['Senin','Selasa','Rabu','Kamis','Jumat','Sabtu'].map(h => <option key={h} value={h}>{h}</option>)}
            </select>
            <input 
                type="date" 
                value={tanggal} 
                onChange={(e) => setTanggal(e.target.value)} 
                style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #cbd5e1' }}
            />
            <button onClick={fetchMonitoring} style={{ padding: '8px 15px', background: '#4361ee', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>🔄 Refresh</button>
        </div>
      </div>

      {/* DASHBOARD RINGKASAN */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', marginBottom: '30px' }}>
          <div style={{ background: 'linear-gradient(135deg, #3b82f6, #2563eb)', color: 'white', padding: '20px', borderRadius: '12px' }}>
              <div style={{ fontSize: '32px', fontWeight: 'bold' }}>{totalKelas}</div>
              <div style={{ fontSize: '14px', opacity: 0.9 }}>Total Jadwal Hari Ini</div>
          </div>
          <div style={{ background: 'linear-gradient(135deg, #10b981, #059669)', color: 'white', padding: '20px', borderRadius: '12px' }}>
              <div style={{ fontSize: '32px', fontWeight: 'bold' }}>{kbmAktif}</div>
              <div style={{ fontSize: '14px', opacity: 0.9 }}>✅ Guru Sudah Masuk</div>
          </div>
          <div style={{ background: 'linear-gradient(135deg, #f43f5e, #e11d48)', color: 'white', padding: '20px', borderRadius: '12px' }}>
              <div style={{ fontSize: '32px', fontWeight: 'bold' }}>{belumHadir}</div>
              <div style={{ fontSize: '14px', opacity: 0.9 }}>⚠️ Belum Absen / Kosong</div>
          </div>
      </div>

      {/* GRID JADWAL KELAS */}
      {loading ? <p style={{textAlign:'center'}}>Memuat data monitoring...</p> : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '20px' }}>
            {jadwal.length === 0 ? <p style={{gridColumn:'1/-1', textAlign:'center', color:'#94a3b8'}}>Tidak ada jadwal pada hari ini.</p> : 
             jadwal.map((j) => (
                <div key={j.jadwal_id} style={{ 
                    background: 'white', borderRadius: '12px', padding: '20px', 
                    borderLeft: j.status_kbm === 'berjalan' ? '6px solid #10b981' : '6px solid #f43f5e',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.05)', position: 'relative'
                }}>
                    <div style={{ position: 'absolute', top: '15px', right: '15px', background: '#f1f5f9', padding: '4px 8px', borderRadius: '6px', fontSize: '12px', fontWeight: 'bold', color: '#64748b' }}>
                        {j.jam_mulai.slice(0,5)} - {j.jam_selesai.slice(0,5)}
                    </div>
                    
                    <h3 style={{ margin: '0 0 5px', color: '#1e293b' }}>{j.nama_kelas}</h3>
                    <div style={{ fontWeight: 'bold', color: '#4361ee', marginBottom: '15px', fontSize: '16px' }}>{j.mapel}</div>
                    
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '15px' }}>
                        <div style={{ width: '40px', height: '40px', background: '#e0e7ff', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px' }}>👨‍🏫</div>
                        <div>
                            <div style={{ fontSize: '13px', fontWeight: 'bold', color: '#334155' }}>{j.nama_guru}</div>
                            <div style={{ fontSize: '11px', color: '#64748b' }}>NIP: {j.nip}</div>
                        </div>
                    </div>

                    <div style={{ borderTop: '1px dashed #e2e8f0', paddingTop: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ fontSize: '13px', color: '#64748b' }}>Status KBM:</div>
                        {j.status_kbm === 'berjalan' ? (
                            <span style={{ background: '#dcfce7', color: '#166534', padding: '5px 10px', borderRadius: '20px', fontSize: '12px', fontWeight: 'bold' }}>
                                {/* Teks deskripsi disesuaikan agar secara harfiah berarti data siswa terproses absen */}
                                ✅ Terabsen ({j.jumlah_siswa_absen} Siswa)
                            </span>
                        ) : (
                            <span style={{ background: '#fee2e2', color: '#991b1b', padding: '5px 10px', borderRadius: '20px', fontSize: '12px', fontWeight: 'bold' }}>
                                ⚠️ Belum Absen
                            </span>
                        )}
                    </div>
                </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default MonitoringKBM;